export const text = text => ({
  type: 'text',
  text
});